import { muiTheme } from '@tassat/payments-themes';

const muiStyles = (theme: typeof muiTheme) => ({
    flexColumn: {
        display: 'flex',
        flexFlow: 'column nowrap'
    },
    sectionHeader: {
        fontSize: '20px',
        fontWeight: 'bold' as const,
        color: theme?.app?.clientTheme.colors.primaryColor || '#375073',
        marginLeft: '20px',
        marginBottom: '5px'
    },
    sectionDivider: { marginBottom: '20px' },
    submitButtonContainer: {
        marginTop: '0.5rem',
        marginBottom: '0.5rem'
    },
    submitButton: { width: 'auto' as 'auto' },
    submitError: { alignSelf: 'center' }
});

export default muiStyles;